import React from 'react';

export const MultiSelectorContext = React.createContext({});

export const MultiSelectorContextConsumer = MultiSelectorContext.Consumer;

export const useMultiSelectContext = () => {
  const context = React.useContext(MultiSelectorContext);
  return context;
};
